$(document).ready(function () {
  
  var Store_language_load_attr = $("html").attr("lang");
  if (Store_language_load_attr === "en") {
    var intervalId = setInterval(function () {
      var currentText = $(".product-list .upper .button").text();
      if (currentText !== "View") {
        $(".product-list .upper .button").text('View');
      } else {
        clearInterval(intervalId); 
      }
    }, 100);
  }

// Declare interval IDs in the outer/global scope
var intervalId = null;
var intervalId1 = null;

$("#weglot-language-he").click(function () {
  setTimeout(function () {
    var Store_language_load_attr = $("html").attr("lang");

    if (Store_language_load_attr === "he") {
      // Clear the other interval if running
      if (intervalId) clearInterval(intervalId);

      intervalId1 = setInterval(function () {
        var currentText = $(".product-list .upper .button").text();
        if (currentText !== "לצפייה") {
          $(".product-list .upper .button").text('לצפייה');
        } else {
          clearInterval(intervalId1);
        }
      }, 100);
    }
  }, 1000);
});

$("#weglot-language-en").click(function () {
  setTimeout(function () {
    var Store_language_load_attr = $("html").attr("lang");

    if (Store_language_load_attr === "en") {
      // Clear the other interval if running
      if (intervalId1) clearInterval(intervalId1);

      intervalId = setInterval(function () {
        var currentText = $(".product-list .upper .button").text();
        if (currentText !== "View") {
          $(".product-list .upper .button").text('View');
        } else {
          clearInterval(intervalId);
        }
      }, 100);
    }
  }, 1000);
});


  
});
